import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { cn } from './Kit';

const { FiChevronUp, FiChevronDown } = FiIcons;

export default function SortableHeader({ label, field, sortField, sortDir, onSort, className }) {
  const active = sortField === field;
  return (
    <th
      className={cn(
        'px-6 py-3 font-medium text-xs uppercase tracking-wide cursor-pointer select-none group',
        className
      )}
      onClick={() => onSort(field)}
    >
      <div className="flex items-center gap-1">
        <span className={active ? 'text-primary' : 'text-gray-500 group-hover:text-gray-700'}>
          {label}
        </span>
        <span className="flex flex-col">
          <SafeIcon
            icon={FiChevronUp}
            className={cn('w-3 h-3 -mb-1', active && sortDir === 'asc' ? 'text-primary' : 'text-gray-300')}
          />
          <SafeIcon
            icon={FiChevronDown}
            className={cn('w-3 h-3', active && sortDir === 'desc' ? 'text-primary' : 'text-gray-300')}
          />
        </span>
      </div>
    </th>
  );
}